module.exports = __webpack_public_path__ + "static/media/[Philm]2011-01-29.b2fc58e1.md";